import { BadgeWithIconProps } from "../../../../../data-model/badgeWithIconProps";
import { OrganizationType } from "../../../../../enums/organizationTypes";
import {
  MedicationClass,
  MedicationCohort,
  MedicationSource,
} from "../data-model/medicationListModel";

export const ORGANIZATION_OPTIONS = [
  { label: "NYCBS", value: OrganizationType.NYCBS_DRUG_CONFIG },
  { label: "Astera", value: OrganizationType.ASTERA },
];

export const CLASS_OPTIONS: { label: string; value: MedicationClass }[] = [
  { label: "Brand", value: "Brand" },
  { label: "Generic", value: "Generic" },
  { label: "Unknown", value: "Unknown" },
];

export const COHORT_OPTIONS: { label: string; value: MedicationCohort }[] = [
  { label: "Green", value: "Green" },
  { label: "Orange", value: "Orange" },
  { label: "Unknown", value: "Unknown" },
];

export const SOURCE_OPTIONS: { label: string; value: MedicationSource }[] = [
  { label: "Manual", value: "manual" },
  { label: "Excel import", value: "intelligent_excel_processing" },
];

export const CLASS_BADGE_LIST: BadgeWithIconProps[] = [
  { id: "Brand", text: "Brand", bgColor: "#eaf2ff", textColor: "#002152" },
  { id: "Generic", text: "Generic", bgColor: "#eefcf4", textColor: "#003d15" },
  { id: "Unknown", text: "Unknown", bgColor: "#f5f5f5", textColor: "#6b6b6b" },
];

export const COHORT_BADGE_LIST: BadgeWithIconProps[] = [
  { id: "Green", text: "Green", bgColor: "#eefcf4", textColor: "#003d15" },
  { id: "Orange", text: "Orange", bgColor: "#fff3e0", textColor: "#8f3200" },
  { id: "Unknown", text: "Unknown", bgColor: "#f5f5f5", textColor: "#6b6b6b" },
];

export const ROWS_PER_PAGE = 25;

export const DEFAULT_CLASS: MedicationClass = "Unknown";
export const DEFAULT_COHORT: MedicationCohort = "Unknown";
